import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'StorageTemperature',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (!this.hasAdministratorOperationalAccessUi())
                this.logout();
        }

        this.GetInfo();
    },

    computed: {
        statsCards() {
            return [
                this.statCard(`إجمالي ${this.ScreenTitle}`, this.Statistics && this.Statistics.count, 'primary', 'ti ti-thermometer'),
                this.statCard(`${this.ScreenTitle} المفعلة`, this.Statistics && this.Statistics.active, 'success', 'ti ti-circle-check'),
                this.statCard(`${this.ScreenTitle} المخفية`, this.Statistics && this.Statistics.notActive, 'warning', 'ti ti-eye-off'),
                this.statCard(`${this.ScreenTitle} المحذوفة`, this.Statistics && this.Statistics.deleted, 'danger', 'ti ti-trash'),
            ];
        }
    },

    filters: {
        moment(date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',

            ScreenTitle: 'درجات حرارة التخزين',
            ScreenTitleSingle: 'درجة حرارة',
            ScreenTitleSingleAl: 'درجة الحرارة',

            Info: [],
            Statistics: [],

            ruleForm: {
                Id: '',
                FromTemperature: '',
                ToTemperature: '',
            },
            rules: {
                FromTemperature: [{ required: true, message: 'الرجاء إدخال درجة البداية', trigger: 'blur' }],
                ToTemperature: [{ required: true, message: 'الرجاء إدخال درجة النهاية', trigger: 'blur' }],
            },
        };
    },

    methods: {
        formatRange(item) {
            if (!item) return '-';
            return `${item.fromTemperature} إلى ${item.toTemperature} °م`;
        },

        resetForm() {
            this.ruleForm.Id = '';
            this.ruleForm.FromTemperature = '';
            this.ruleForm.ToTemperature = '';
            if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
        },

        getFormPayload(id) {
            const from = Number(this.ruleForm.FromTemperature);
            const to = Number(this.ruleForm.ToTemperature);

            if (!Number.isFinite(from) || !Number.isFinite(to)) {
                this.$helper.ShowMessage('error', 'خطاء بالبيانات', 'الرجاء إدخال درجات حرارة صحيحة.');
                return null;
            }
            if (from > to) {
                this.$helper.ShowMessage('warning', 'تحقق من المجال', 'لا يمكن أن تكون درجة البداية أكبر من درجة النهاية.');
                return null;
            }

            return {
                Id: Number(id),
                FromTemperature: from,
                ToTemperature: to,
            };
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            this.$http.GetStorageTemperatures(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const payload = this.getFormPayload(0);
                    if (!payload) return;

                    this.$blockUI.Start();
                    this.$http.AddStorageTemperature(payload)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.resetForm();
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.ruleForm.Id = item.id;
            this.ruleForm.FromTemperature = item.fromTemperature;
            this.ruleForm.ToTemperature = item.toTemperature;
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const payload = this.getFormPayload(this.ruleForm.Id);
                    if (!payload) return;

                    this.$blockUI.Start();
                    this.$http.EditStorageTemperature(payload)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.resetForm();
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: 'هل أنت متأكد من تغير حالة العرض؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusStorageTemperature(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: 'هل أنت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteStorageTemperature(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },
    }
}
